import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { Plus, Trash2, GripVertical } from 'lucide-react';

const card = { background: 'var(--field)', border: '1px solid var(--rule-strong)', borderRadius: 16, padding: '16px 18px', marginBottom: 16 };
const inp = { padding: '8px 12px', background: 'var(--paper-sunk)', border: '1px solid var(--rule-strong)', borderRadius: 8, color: 'var(--ink)', fontSize: 'var(--t-note)' };

const KEY_LABELS = {
  power_company: '電力会社', household: '世帯タイプ', meter: '検針票・マイページ',
  result: '結果', acquired_product: '獲得商材', lost_reason: '失注理由', prevent_stage: '防止ステージ'
};

export default function AdminEnums() {
  const [allEnums, setAllEnums] = useState([]);
  const [newVal, setNewVal]     = useState({});
  const [newKey, setNewKey]     = useState({});
  const [loading, setLoading]   = useState(true);

  const load = async () => {
    setLoading(true);
    try { setAllEnums(await api.getAllEnums()); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const grouped = allEnums.reduce((acc, e) => {
    if (!acc[e.enum_key]) acc[e.enum_key] = [];
    acc[e.enum_key].push(e);
    return acc;
  }, {});

  const handleAdd = async (key) => {
    const v = newVal[key]?.trim();
    if (!v) return;
    try {
      await api.createEnum({ enum_key: key, value: v, sort_order: (grouped[key]?.length || 0) });
      setNewVal(p => ({ ...p, [key]: '' }));
      load();
    } catch (e) { alert(e.message); }
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`選択肢「${item.value}」を削除します。よろしいですか？\n（今後の入力で選べなくなります。過去の記録は残ります）`)) return;
    try { await api.deleteEnum(item.id); load(); } catch (e) { alert(e.message); }
  };

  const handleToggle = async (id, is_active) => {
    try { await api.updateEnum(id, { is_active: is_active ? 0 : 1 }); load(); } catch (e) { alert(e.message); }
  };

  const handleAddNewKey = async () => {
    const k = newKey.key?.trim(); const v = newKey.val?.trim();
    if (!k || !v) return;
    try {
      await api.createEnum({ enum_key: k, value: v, sort_order: 0 });
      setNewKey({});
      load();
    } catch (e) { alert(e.message); }
  };

  return (
    <div style={{ maxWidth: 880, margin: '0 auto', padding: 'var(--s6) var(--s4) 120px' }}>
      <h1 style={{ margin: '0 0 20px', fontSize: 20, fontWeight: 800, color: 'var(--ink)'}}> 選択肢管理</h1>
      {loading ? (
        <div style={{ color: 'var(--ink-mute)', textAlign: 'center', padding: 40 }}>読み込み中...</div>
      ) : (
        Object.entries(grouped).map(([key, items]) => (
          <div key={key} style={card}>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--ink-soft)', marginBottom: 14 }}>{KEY_LABELS[key] || key}</div>
            {items.map(item => (
              <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, opacity: item.is_active ? 1 : 0.4 }}>
                <GripVertical size={14} color="var(--ink)" style={{ cursor: 'grab' }} />
                <span style={{ flex: 1, fontSize: 'var(--t-note)', color: 'var(--ink)' }}>{item.value}</span>
                <button onClick={() => handleToggle(item.id, item.is_active)} style={{ fontSize: 'var(--t-note)', padding: '3px 10px', borderRadius: 6, border: '1px solid var(--rule-strong)', background: 'transparent', color: item.is_active ? 'var(--gain)' : 'var(--ink-mute)', cursor: 'pointer' }}>
                  {item.is_active ? '有効' : '無効'}
                </button>
                <button onClick={() => handleDelete(item)} style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--loss-bg)', border: '1px solid #6B3A36', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Trash2 size={12} color="#6B3A36" />
                </button>
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <input value={newVal[key] || ''} onChange={e => setNewVal(p => ({ ...p, [key]: e.target.value }))} onKeyDown={e => e.key === 'Enter' && handleAdd(key)} style={{ ...inp, flex: 1 }} placeholder="新しい選択肢を追加" />
              <button onClick={() => handleAdd(key)} style={{ padding: '8px 14px', background: 'var(--grad-primary)', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 700, fontSize: 'var(--t-note)', cursor: 'pointer' }}>
                <Plus size={14} />
              </button>
            </div>
          </div>
        ))
      )}

      {/* 新しいカテゴリ */}
      <div style={{ ...card, border: '1px dashed var(--rule-strong)' }}>
        <div style={{ fontSize: 'var(--t-note)', fontWeight: 700, color: 'var(--ink-mute)', marginBottom: 12 }}>新しいカテゴリを追加</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input value={newKey.key || ''} onChange={e => setNewKey(p => ({ ...p, key: e.target.value }))} style={{ ...inp, flex: 1, minWidth: 120 }} placeholder="カテゴリキー (例: area)" />
          <input value={newKey.val || ''} onChange={e => setNewKey(p => ({ ...p, val: e.target.value }))} style={{ ...inp, flex: 2, minWidth: 160 }} placeholder="最初の選択肢" />
          <button onClick={handleAddNewKey} style={{ padding: '8px 16px', background: '#10b98122', border: '1px solid #10b98144', borderRadius: 8, color: 'var(--gain)', fontWeight: 700, fontSize: 'var(--t-note)', cursor: 'pointer' }}>追加</button>
        </div>
      </div>
    </div>
  );
}
